import { Space } from '@billy/design-system'
import React, { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

export interface EmptyStateProps {
  buttonText: string
  children: ReactNode
  hideButton?: boolean
  image: ReactNode
  onButtonClick?: () => void
}

export const EmptyState = ({
  buttonText,
  children,
  hideButton,
  image,
  onButtonClick,
}: EmptyStateProps): ReactElement => (
  <Styled.EmptyStateWrapper>
    {image}
    <Space size="s12" />
    <Styled.Text colorVariant="secondary">{children}</Styled.Text>
    {!hideButton && (
      <>
        <Space size="s12" />
        <Styled.Button onClick={onButtonClick}>{buttonText}</Styled.Button>
      </>
    )}
  </Styled.EmptyStateWrapper>
)
